import { render, staticRenderFns } from "./DashboardOverviewNumberOfConceptsTile.vue?vue&type=template&id=49c23f0a"
import script from "./DashboardOverviewNumberOfConceptsTile.vue?vue&type=script&lang=js"
export * from "./DashboardOverviewNumberOfConceptsTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports